module.exports = __webpack_public_path__ + "media/5-3.1614c4da.mp4";